import { useEffect, useState } from "react"
import { GetHeaders } from "services/api"
import { Create, Read } from "services/core"
import { parseStrapiImage } from "utils"

const AI_TIMEOUT_MS = 60000

export default function useController() {

    const [loading, setLoading] = useState(null)
    const [registers, setRegisters] = useState([])

    const init = async () => {
        const result = await Read("upload/files", "?pagination[pageSize]=100000")
        setRegisters(result?.length ? result : [])
    }

    const requestAiSuggestion = async (file) => {
        const headers = await GetHeaders(true)
        const controller = new AbortController()
        const timer = setTimeout(() => controller.abort(), AI_TIMEOUT_MS)

        let response = null;
        try {
            response = await fetch("https://n8n.x-apps.services/webhook/5bcbf77e-c8a4-4b46-b6db-e747b7ad195c", {
                ...headers,
                method: "POST",
                body: JSON.stringify({ url: parseStrapiImage(file?.url) }),
                signal: controller.signal,
            });
        } finally {
            clearTimeout(timer)
        }

        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }

        if (!response.ok) {
            throw new Error(data?.message || `Request failed (${response.status})`);
        }

        return data?.title || null;
    };

    const buildCaptionWithStatus = (caption, status) => {
        const base = String(caption || '').replace(/\s*\|?\s*ai-qualifier:(success|failed)\s*$/i, '').trim();
        const marker = `ai-qualifier:${status}`;
        return base ? `${base} | ${marker}` : marker;
    }

    const persistImageResult = async ({ id, name, status }) => {
        if (!id || !status) return;

        const payload = { id, status };
        if (status === 'success' && name) {
            payload.name = name;
        }

        await Create("image-qualifier/update-image-name", payload);
    }

    const handleUploadAll = async (files) => {
        try {
            if (!!loading) return;
            setLoading("all");

            for (const file of files || []) {
                try {
                    const suggestion = await requestAiSuggestion(file);
                    const hasSuggestion = !!String(suggestion || '').trim();
                    const status = hasSuggestion ? 'success' : 'failed';

                    await persistImageResult({
                        id: file?.id,
                        name: suggestion,
                        status,
                    });

                    setRegisters((prev) =>
                        prev?.map((m) =>
                            m?.id === file?.id
                                ? {
                                    ...m,
                                    suggestion,
                                    name: hasSuggestion ? suggestion : m?.name,
                                    caption: buildCaptionWithStatus(m?.caption, status),
                                }
                                : m
                        )
                    );
                } catch (e) {
                    console.log(`AI suggestion failed for file ${file?.id}:`, e);
                    try {
                        await persistImageResult({
                            id: file?.id,
                            status: 'failed',
                        });
                        setRegisters((prev) =>
                            prev?.map((m) =>
                                m?.id === file?.id
                                    ? { ...m, caption: buildCaptionWithStatus(m?.caption, 'failed') }
                                    : m
                            )
                        );
                    } catch (persistErr) {
                        console.log(`Persist failed status for file ${file?.id}:`, persistErr);
                    }
                }
            }

            setLoading(null);
        } catch (e) {
            console.log("something wrong", e)
            setLoading(null);
        }
    };

    useEffect(() => {
        init();
    }, [])

    return {
        loading,
        registers,
        handleUploadAll
    }
}
